var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWagerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9274 5.12364H21.6271V2.20737C21.6271 0.990254 20.6369 0 19.4198 0H3.40967C1.64294 0 0.186272 1.35134 0.0181179 3.07462C-0.00756234 3.19639 0.00158211 2.11137 0.00158211 18.9169C0.00158211 20.7961 1.53041 22.325 3.40962 22.325H21.9274C23.1445 22.325 24.1347 21.3348 24.1347 20.1176V7.33101C24.1348 6.1139 23.1446 5.12364 21.9274 5.12364ZM3.40967 1.51623H19.4198C19.8009 1.51623 20.1109 1.82628 20.1109 2.20741V5.12369H3.40967C2.39605 5.12369 1.56628 4.32234 1.52004 3.31996C1.56623 2.31753 2.39601 1.51623 3.40967 1.51623ZM21.9274 20.8088H3.40967C2.36649 20.8088 1.51781 19.9601 1.51781 18.9169V6.06528C2.05942 6.42808 2.71024 6.63982 3.40967 6.63982H21.9274C22.3086 6.63982 22.6186 6.94988 22.6186 7.33101V10.4044H16.9136C14.9707 10.4044 13.39 11.9851 13.39 13.928C13.39 15.8709 14.9707 17.4516 16.9136 17.4516H22.6186V20.1176C22.6186 20.4987 22.3086 20.8088 21.9274 20.8088ZM22.6186 15.9355H16.9136C15.8067 15.9355 14.9061 15.035 14.9061 13.928C14.9061 12.8211 15.8067 11.9206 16.9136 11.9206H22.6186V15.9355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1934 15.0267C17.8002 15.0267 18.2921 14.5348 18.2921 13.928C18.2921 13.3213 17.8002 12.8294 17.1934 12.8294C16.5866 12.8294 16.0947 13.3213 16.0947 13.928C16.0947 14.5348 16.5866 15.0267 17.1934 15.0267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagerIcon);
export default __webpack_public_path__ + "static/media/wager-icon.299ff6e017d3bfd8e2e284635f6f0091.svg";
export { ForwardRef as ReactComponent };